import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private http: HttpClient
  ) { }


  getPaymentReports(pageNumber: string, startDate: any, endDate: any, sortBy?: string, sortDirection?: string) {
    let params = new HttpParams().set('page', pageNumber)
    if (startDate != null && startDate != '') {
      params = params.set('startDate', startDate);
    }
    if (endDate != null && endDate != '') {
      params = params.set('endDate', endDate);
    }
    if (sortBy != null && sortBy != '') {
      params = params.set('sortBy', sortBy);
    }
    if (sortDirection != null && sortDirection != '') {
      params = params.set('sortDirection', sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/paymentReports';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    console.log(url + '?' + params);
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  getClientEngagementReport(pageNumber: string, startDate: any, endDate: any, sortBy?: string, sortDirection?: string) {
    let params = new HttpParams().set('page', pageNumber)
    if (startDate != null && startDate != '' && startDate != 'Invalid date') {
      params = params.set('startDate', startDate);
    }
    if (endDate != null && endDate != '' && endDate != 'Invalid date') {
      params = params.set('endDate', endDate);
    }
    if (sortBy != null && sortBy != '') {
      params = params.set('sortBy', sortBy);
    }
    if (sortDirection != null && sortDirection != '') {
      params = params.set('sortDirection', sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/clientEngagementReport';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    console.log(url + '?' + params);
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  getMessageUsageReport(pageNumber: string, sortBy?: string, sortDirection?: string) {
    let params = new HttpParams().set('page', pageNumber)
    // if (startDate != null && startDate != '') {
    //   params = params.set('startDate', startDate);
    // }
    // if (endDate != null && endDate != '') {
    //   params = params.set('endDate', endDate);
    // }
    if (sortBy != null && sortBy != '') {
      params = params.set('sortBy', sortBy);
    }
    if (sortDirection != null && sortDirection != '') {
      params = params.set('sortDirection', sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/messageUsageReport';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    console.log(url + '?' + params);
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  getBusinessTypeReport(pageNumber: string, subscriptionType: string, startDate?: any, endDate?: any, sortBy?: string, sortDirection?: string) {
    let params = new HttpParams().set('page', pageNumber).set('subscriptionType', subscriptionType);
    if (startDate != null && startDate != '' && startDate != 'Invalid date') {
      params = params.set('startDate', startDate);
    }
    if (endDate != null && endDate != '' && endDate != 'Invalid date') {
      params = params.set('endDate', endDate);
    }
    if (sortBy != null && sortBy != '') {
      params = params.set('sortBy', sortBy);
    }
    if (sortDirection != null && sortDirection != '') {
      params = params.set('sortDirection', sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/businessTypeReport';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    console.log(url + '?' + params);
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  exportReport(reportType: string, startDate: any, endDate: any, subscriptionType?: string) {
    let params = new HttpParams().set('reportType', reportType);
    if (startDate != null && startDate != '') {
      params = params.set('startDate', startDate);
    }
    if (endDate != null && endDate != '') {
      params = params.set('endDate', endDate);
    }
    if (subscriptionType != null && subscriptionType != '') {
      params = params.set('subscriptionType', subscriptionType);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/export';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
      }),
      params: params,
      observe: 'response' as const,
      responseType: 'blob' as const,
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  getBusinessClientReports(pageNumber: string, startDate: any, endDate: any, sortBy?: string, sortDirection?: string) {
    let params = new HttpParams().set('page', pageNumber)
    if (startDate != null && startDate != '') {
      params = params.set('startDate', startDate);
    }
    if (endDate != null && endDate != '') {
      params = params.set('endDate', endDate);
    }
    if (sortBy != null && sortBy != '') {
      params = params.set('sortBy', sortBy);
    }
    if (sortDirection != null && sortDirection != '') {
      params = params.set('sortDirection', sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/reports/businessClientReports';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    console.log(url + '?' + params);
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

}
